var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"action-wrap"}},[(!_vm.forOverview)?_c('h2',[_vm._v("Stats")]):_vm._e(),_c('CharacterPhysicalAttributes'),_c('CharacterSkills'),(!_vm.forOverview)?_c('SaveButtons',{on:{"clear":_vm.clearStats}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }